import React from "react";

export const Price = ({ price }) => {
  const formattedPrice =
    (price &&
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(price)) ||
    "$0.00";

  return <>{formattedPrice.replace(".00", "")}</>;
};
